<template>
	<div id="app">
		<v-app id="inspire">
			<v-snackbar right bottom v-model="snackbar" outlined color="primary">
				{{ getTextMessage }}
				<template v-slot:action="{ attrs }">
					<v-btn color="white" text v-bind="attrs" @click="this.setStatusMessage(false)"> Close </v-btn>
				</template>
			</v-snackbar>
		</v-app>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	name: 'Messages',
	data() {
		return {
			text: `Hello !`,
			timeout: 2000000,
		};
	},

	computed: {
		...mapGetters({
			getTextMessage: 'settings/getTextMessage',
			getStatusMessage: 'settings/getStatusMessage',
		}),
		snackbar: {
			get: function (value) {
				return this.getStatusMessage;
			},
			set: function (value) {
				if (!value) {
					this.setStatusMessage(false);
				}
				return this.getStatusMessage;
			},
		},
	},
	methods: {
		...mapMutations({
			setTextMessage: 'settings/setTextMessage',
			setStatusMessage: 'settings/setStatusMessage',
		}),
	},
};
</script>
